import { Stack, StackProps } from '@mui/material';
import { PropsWithChildren, forwardRef } from 'react';

interface IBlurredBox extends PropsWithChildren, StackProps {}

export const BlurredStack = forwardRef<any, IBlurredBox>(
  ({ children, sx = {}, ...others }, ref) => {
    return (
      <Stack
        {...others}
        ref={ref}
        sx={{
          backgroundColor: 'background.paper',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255, 255, 255, 0.10)',
          ...sx,
        }}
      >
        {children}
      </Stack>
    );
  },
);
